import type { Copy } from "@b2bportal/air-exchange-api";
import type { IChangeFlightEligibilityClasses } from "@b2bportal/core-types";
import type { IChangeFlightEligibilityData } from "@tenant/flights";
import { Button, ButtonTypeEnum } from "@tenant/ui";
import DOMPurify from "dompurify";

export interface IChangeFlightEligibilityVoidableProps {
  classes?: Partial<
    IChangeFlightEligibilityClasses & {
      goToExchangeBtn: string;
      openCancelBtn: string;
    }
  >;
  copy: IChangeFlightEligibilityData["copy"];
  onContinueToExchange: () => void;
  onOpenFlightCancel: () => void;
  policyCopy?: Copy;
}

export const ChangeFlightEligibilityVoidable = (
  props: IChangeFlightEligibilityVoidableProps
) => {
  const {
    classes,
    copy,
    onContinueToExchange,
    onOpenFlightCancel,
    policyCopy,
  } = props;

  return (
    <div className={classes?.modalContent}>
      {policyCopy != null && (
        <div className={classes?.contentHeader}>
          <span
            className={classes?.contentTitle}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(policyCopy.title),
            }}
          />
          {policyCopy.body.map((item) => (
            <span
              key={item}
              className={classes?.contentBody}
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item) }}
            />
          ))}
        </div>
      )}
      <div className={classes?.contentActions}>
        <Button
          buttonType={ButtonTypeEnum.Primary}
          className={classes?.openCancelBtn}
          onClick={onOpenFlightCancel}
        >
          {copy.cancelFlightBtn}
        </Button>
        <Button
          buttonType={ButtonTypeEnum.Secondary}
          className={classes?.goToExchangeBtn}
          onClick={onContinueToExchange}
        >
          {copy.continueToExchangeBtn}
        </Button>
      </div>
    </div>
  );
};
